'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmailCapturePromptMessage = undefined;

var _messageTypes = require('../constants/messageTypes');

var _isType = require('./isType');

var isEmailCapturePromptMessage = exports.isEmailCapturePromptMessage = (0, _isType.isType)(_messageTypes.EMAIL_CAPTURE_PROMPT);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/isEmailCapturePromptMessage.js
// module id = 99
// module chunks = 2 3